<template>
	<div class="bg-1">
        <Header bgClass="bg-brand-green" />
		<div class="flex justify-end">
			<!-- <img src="@/assets/images/girl-hairs.svg" /> -->
		</div>
		<form @submit.prevent="handleFormSubmit" class="px-6 py-8 rounded-lg bg-brand-blue">

			<div v-if="'full_name' in form.fields" class="mb-6 text-white">
				<label for="name" class="block mb-2 text-lg"
					>Name</label
				>
				<input
					type="text"
					id="name"
					name="name"
					class="w-full p-3 bg-[#EFEAD6] text-black rounded-md outline-none"
					placeholder="Full Name"
					v-model.trim="form.fields.full_name"
					maxlength="100"
					@blur="validateField('full_name')"
				/>
				<Error class="mt-2" :errors="form.errors.full_name" />
			</div>
			<div v-if="'email' in form.fields" class="mt-6">
				<label for="email" class="block mb-2 text-lg text-white"
					>Email</label
				>
				<input
					type="email"
					id="email"
					name="email"
					class="w-full p-3 bg-[#EFEAD6] text-black  rounded-md outline-none"
					placeholder="Enter Email"
					v-model.trim="form.fields.email"
					maxlength="100"
					@blur="validateField('email')"
				/>
				<Error class="mt-2" :errors="form.errors.email" />
			</div>
			<div class="mt-6">
				<div>
					<label for="age" class="block mb-2 text-lg text-white"
						>Age Group</label
					>
					<div class="flex w-full">
						<span
							v-for="age in options.ageGroup"
							:key="age.value"
							@click="
								;(form.fields.age_group = age.value) &&
									(form.errors.age_group = [])
							"
							class="w-1/3 py-2 mx-2 text-sm font-bold text-center transition duration-150 ease-in-out border rounded"
							:class="age.value === form.fields.age_group ? 'bg-white border-b-4 border-r-4 border-r-[#EFCC64] border-b-[#EFCC64]': 'bg-[#EFEAD6]'"
						>
							{{ age.label }}
						</span>
					</div>
					<Error class="mt-2" :errors="form.errors.age_group" />
				</div>
			</div>
			<div class="mt-6">
				<div>
					<label for="gender"  class="block mb-2 text-lg text-white"
						>Sex</label
					>
					<div class="flex w-full">
						<span
							v-for="gender in options.gender"
							:key="gender.value"
							@click="
								;(form.fields.gender = gender.value) &&
									(form.errors.gender = [])
							"
							class="w-1/3 py-2 mx-2 text-sm font-bold text-center transition duration-150 ease-in-out border rounded"
							:class="gender.value === form.fields.gender ? 'bg-white border-b-4 border-r-4 border-r-[#EFCC64] border-b-[#EFCC64]': 'bg-[#EFEAD6]'"
						>
							{{ gender.label }}
						</span>
					</div>
					<Error class="mt-2" :errors="form.errors.gender" />
				</div>
			</div>
			<div class="mt-6">
				<div>
					<label class="block mb-2 text-lg text-white">College Year</label>
					<div class="flex justify-between -mx-2">
						<span
							v-for="cy in options.collegeYears"
							:key="cy.value"
							@click="
								;(form.fields.college_year = cy.value) &&
									(form.errors.college_year = [])
							"
                            class="w-1/3 py-2 mx-2 text-sm font-bold text-center transition duration-150 ease-in-out border rounded"
							:class="cy.value === form.fields.college_year ? 'bg-white border-b-4 border-r-4 border-r-[#EFCC64] border-b-[#EFCC64]': 'bg-[#EFEAD6]'"
							v-html="cy.label"
						></span>
					</div>
					<Error class="mt-2" :errors="form.errors.college_year" />
				</div>
			</div>
			<div class="mt-6">
				<label for="state" class="block mb-2 text-lg text-white">
					State where college is located:
				</label>
				<div class="px-3 bg-[#EFEAD6] rounded-md">
					<select
						id="state"
						name="state"
						v-model="form.fields.state"
						class="w-full py-3 bg-[#EFEAD6]  rounded-md outline-none"
					>
						<option disabled :value="null">Select</option>
						<option
							v-for="state in options.states"
							:value="state.id"
							:key="state.id"
						>
							{{ state.name }}
						</option>
					</select>
				</div>
				<Error
					class="mt-2"
					v-if="!form.fields.state"
					:errors="form.errors.state"
				/>
			</div>

			<div v-if="loading.cities" class="flex justify-center mt-6">
				<span class="text-xs text-center text-white">
					<!-- <img src="@/assets/images/loading.svg" class="w-12 h-12 mx-auto" /> -->
					Loading Cities...
				</span>
			</div>
			<div v-if="options.cities.length" class="mt-6">
				<label class="block mb-2 text-lg text-white">
					City where college is located:
				</label>
				<div class="px-3 bg-[#EFEAD6] rounded-md">
					<select
						v-model="form.fields.city"
						class="w-full py-3 bg-[#EFEAD6]  rounded-md outline-none"
					>
						<option :value="null">Select</option>
						<option
							v-for="city in options.cities"
							:value="city.id"
							:key="city.id"
						>
							{{ city.name }}
						</option>
					</select>
				</div>
				<Error
					class="mt-2"
					v-if="!form.fields.city"
					:errors="form.errors.city"
				/>
			</div>

			<div v-if="loading.colleges" class="flex justify-center mt-6">
				<span class="text-xs text-center text-white">
					<!-- <img src="@/assets/images/loading.svg" class="w-12 h-12 mx-auto" /> -->
					Loading Colleges...
				</span>
			</div>
			<div v-if="options.colleges.length" class="mt-6">
				<label class="block mb-2 text-lg text-white"
					>Select your college:</label
				>
				<div class="px-3 bg-[#EFEAD6] rounded-md">
					<select
						v-model="form.fields.college"
						@change="form.errors.college = []"
						class="w-full py-3 bg-[#EFEAD6]  rounded-md outline-none"
					>
						<option :value="null">Select</option>
						<option
							v-for="college in options.colleges"
							:value="college.id"
							:key="college.id"
						>
							{{ college.name }}
						</option>
					</select>
				</div>
				<Error class="mt-2" :errors="form.errors.college" />
			</div>
			<div class="mt-6">
				<label for="shero" class="block mb-2 text-lg text-white">
					Do you want to be a PERIOD SHERO?
				</label>
				<div class="flex w-full">
					<span
						v-for="periodShero in [{label:'Yes', value: true,},{label: 'No', value: false}]"
						:key="periodShero.value"
						@click="
							;(form.fields.period_shero = periodShero.value) &&
								(form.errors.period_shero = [])
						"
						class="w-1/3 py-2 mx-2 text-sm font-bold text-center transition duration-150 ease-in-out border rounded"
						:class="periodShero.value === form.fields.period_shero ? 'bg-white border-b-4 border-r-4 border-r-[#EFCC64] border-b-[#EFCC64]': 'bg-[#EFEAD6]'"
					>
						{{ periodShero.label }}
					</span>
				</div>
				<Error class="mt-2" :errors="form.errors.period_shero" />
			</div>
			<div class="mt-6">
				<label for="products" class="block mb-3 text-lg text-white">
					Please select the product you have received
				</label>
				<div class="flex flex-wrap items-stretch -mx-1">
					<div
						v-for="(item, index) in options.products"
						:key="`${index}_i`"
						class="product-item"
					>
						<div
							class="select-box"
							:class="{
								selected: form.fields.products.includes(item.uuid),
							}"
							@click="
								form.fields.products.includes(item.uuid)
									? (form.fields.products = form.fields.products.filter((i) => i !== item.uuid))
									: form.fields.products.push(item.uuid)
								"
							>
							<i></i>
							<div class="sb__img">
								<img
								:src="`/selena/assets/images/product-images/${item.slug}.png`"
								:alt="item.name"
								/>
							</div>
						</div>
						<span class="sb__name">
							<b></b>
							{{ item.name }}
						</span>
					</div>
					<Error class="mt-2" :errors="form.errors.products" />
				</div>
			</div>
			<div class="pb-8 mt-10">
				<button
					class="w-full py-3 font-serif text-2xl text-black rounded-lg outline-none bg-brand-yellow btn "
					type="submit"
					:class="{'btn--loading': loading.formSubmit}"
					:disabled="loading.formSubmit"
				>
					<span>SUBMIT</span>
				</button>
			</div>
		</form>
	</div>
</template>

<script>
import {
	defineComponent,
	onMounted,
	reactive,
	toRefs,
	watch,
	computed,
	watchEffect,
} from 'vue'
import { useStore } from 'vuex'
import Error from '@/components/Error.vue'
import useValidateForm from '@/hooks/useValidateForm'
import { moveToNextRoute } from '@/hooks/useNextRoute'
import useStatusCheck from '@/hooks/useStatusCheck'
import {
	getStatesList,
	getCityListByState,
	getCollegeListByCity,
	updateParticipateInfo,
	getProducts,
} from '@/api'
import Header from '@/components/Header.vue'
import useEventCheck from "@/hooks/useEventCheck";


export default defineComponent({
	name: 'Details',
	components: { Error, Header },

	setup(props, {}) {
		useStatusCheck()
		useEventCheck()
		const store = useStore()
		const state = reactive({
			options: {
				ageGroup: [
					{ label: '18-20 years', value: 'TEEN' },
					{ label: '20-24 years', value: 'ADULT' },
					{ label: '24+ years', value: 'TWENTYFOUR_PLUS' },
				],
				gender: [
					{ label: 'Male', value: 'M' },
					{ label: 'Female', value: 'F' },
				],
				collegeYears: [
					{ label: '1<sup>st</sup>', value: 1 },
					{ label: '2<sup>nd</sup>', value: 2 },
					{ label: '3<sup>rd</sup>', value: 3 },
					{ label: '4<sup>th</sup>', value: 4 },
				],
				states: [],
				colleges: [],
				cities: [],
				products: [],
			},
			isCitiesLoading: false,
			isCollegedLoading: false,
			loading: { cities: false, colleges: false, formSubmit: false },
		})

		const form = reactive({
			fields: {
				age_group: null,
				gender: null,
				college_year: null,
				state: null,
				city: null,
				college: null,
				perio: undefined,
                full_name: null, email: null,
				period_shero: null,
				products: [],
			},
			errors: {
                full_name: null, email: null,
				gender: [],
				email: [],
				age_group: [],
				college_year: [],
				state: [],
				city: [],
				college: [],
				period_shero: [],
				products: [],
			},
			validations: {
                full_name: [{ name: 'required', message: 'Please enter your Name' }],
					email: [{ name: 'required', message: 'Please enter your email' }],
				age_group: [{ name: 'required', message: 'Please select age group' }],
				gender: [{ name: 'required', message: 'Please select gender' }],
				college_year: [
					{ name: 'required', message: 'Please select college year' },
				],
				state: [{ name: 'required', message: 'Please select college state' }],
				city: [{ name: 'required', message: 'Please select college city' }],
				college: [{ name: 'required', message: 'Please select your college' }],
				period_shero: [{ name: 'required', message: 'Please select an option' }],
				products: [{ name: 'required', message: 'Please select at least one product' }],
			},
		})

		const { validateForm, validateField } = useValidateForm(form)

		async function handleFormSubmit(e) {
			e && e.preventDefault()
			const isFormValid = validateForm(true)
			if (!isFormValid) return
			state.loading.formSubmit = true
			try{
				const { data, status } = await updateParticipateInfo({ ...form.fields })
				if (status === 200) {
					state.loading.formSubmit = false

					moveToNextRoute(data.status)
				} else if (status === 400) {
					state.loading.formSubmit = false
					alert('Please fill correct values')
					Object.assign(form.errors, data)
				}
			}catch{
				state.loading.formSubmit = false
			}
		}

		onMounted(async () => {
			const { data } = await getStatesList()
			state.options.states = data.sort((a, b) => (a.name > b.name ? 1 : -1))
			const { data:productsData } = await getProducts()
			state.options.products = productsData
		})

		watch(
			() => form.fields.state,
			async (stateId) => {
				if (!stateId) return
				state.loading.cities = true
				state.options.colleges = []
				form.fields.college = null
				state.options.cities = []
				form.fields.city = null
				const { data } = await getCityListByState(stateId)
				state.options.cities = data.sort((a, b) => (a.name > b.name ? 1 : -1))
				state.loading.cities = false
			},
		)

		watch(
			() => form.fields.city,
			async (cityId) => {
				if (!cityId) return
				state.loading.colleges = true
				state.options.colleges = []
				form.fields.college = null
				const { data } = await getCollegeListByCity(cityId)
				state.options.colleges = data.sort((a, b) => (a.name > b.name ? 1 : -1))
				state.loading.colleges = false
			},
		)

		return {
			...toRefs(state),
			handleFormSubmit,
			validateField,
			form,
		}
	},
})
</script>
<style lang="postcss" scoped>
.bg-1 {
	background: url('@/assets/bg-1.png') no-repeat 0 0 / cover;
	padding: 16px;
}
.select-box {
  width: 143px;
  height: 143px;
  border-radius: 12px;
  border-width: 2px;
  border-style: solid;
  border-color: #A8B5E8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  margin: 0 auto;
  gap: 10.51px;
}
.select-box.selected {
  border-color: #fff;
  ;
  box-shadow: 0 0 0 2px #fff;
}
.select-box > i {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: 2px solid #A8B5E8;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.select-box.selected > i {
  border-color: #006EB5;
  background: #006EB5 url('@/assets/small-tick.svg') no-repeat center center;
  background-size: 16px 16px;
}
.sb__name {
  margin-top: 12px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  width: 100%;
  word-break: break-word;
}
.sb__img img {
  max-width: 100px;
  max-height: 100px;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}
.flex.flex-wrap.items-stretch.-mx-1 {
  gap: 24px 0;
  justify-content: center;
}
.product-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	flex: 1 1 30%;
	max-width: 240px;
  }
</style>
